export default {
  lastUpdate: null,
  driverLocations: [],
  driverMarkers: [],
  driverOptions: [],
  isDriverOptionsLoading: true,
  driverInfo: {
    id: null,
    call_number: '',
    licence: '',
    status: null,
    car_year: null,
    name: '',
    gender: null,
    car_brand: '',
    account: '',
    contact1: '',
    contact2: '',
    note: '',
    service_list: [],
    updated_at: null,
    lat: null,
    lng: null,
  },
  sortBy: true,
  /* markerDriverLocations: [], */
  carStatusCount: {
    rest: 0,
    vacant: 0,
    dispatched: 0,
    hired: 0,
    shift: 0,
    logout: 0,
    disappear: 0,
    suspension: 0,
  },
  dispatchInfo: {
    name: '',
    area_capacity: null,
    dispatch_strategy: '',
    in_line_name1: '',
    in_line_name2: '',
    note: '',
  },
  shiftInfo: {
    name: '',
    area_capacity: null,
    dispatch_strategy: '',
    in_line_time1_start: '',
    in_line_time1_end: '',
    in_line_time2_start: '',
    in_line_time2_end: '',
    note: '',
  },
  autoLocation: {
    longitude: null,
    latitude: null,
  },
  mapCenter: {
    lat: null,
    lng: null,
  },
  activeTab: 'driver',
  driverTabAddr: '',
  cancelAddrRequest: null,
  isTabLoading: false,
  isTrack: false,
}



// WEBPACK FOOTER //
// ./src/store/driverMonitor/state.js